<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="row justify-content-center">
    <div *ngIf="logicalConfig.crs.properties.layersModeEnabled" class="col-11">
        <winde-tabs-nav
                (tabChanged)="changeLayerTab($event)"
                [activeTab]="activeLayerTab"
                [customClass]="'tabs-nav--horizontal layers-tabs'"
                [tabsList]="layerNames"
        ></winde-tabs-nav>
    </div>

    <div *ngIf="activeLayerTab !== undefined" class="col-11">
        <winde-project-dialog-layer-general
                [layerIndex]="activeLayerTab"
                [logicalConfig]="logicalConfig"
                [viewInReadOnly]="viewInReadOnly"
        ></winde-project-dialog-layer-general>


        <winde-select-products
                [customerId]="project.customerId"
                [defaultBuProductPerLayer]="logicalConfig.crs.properties.defaultBuProductPerLayer"
                [defaultTuProductPerLayer]="logicalConfig.crs.properties.defaultTuProductPerLayer"
                [engineType]="project.engineType"
                [frozenPairs]="frozenPairs"
                [layerIndex]="activeLayerTab"
                [productUnits]="logicalConfig.crs.properties.productUnits"
                [selectedProductsPerLayer]="logicalConfig.crs.properties.selectedProductsPerLayer"
                [viewInReadOnly]="readonlyProductsConfiguration"
        ></winde-select-products>

        <ng-container *ngIf="logicalConfig.crs.properties.layersModeEnabled && !viewInReadOnly">
            <div class="form-group row justify-content-start mt-3">
                <div class="col-5">
                    <button
                            (click)="copySettingsFromLayer(copyFromLayerIndex)"
                            class="btn btn-link btn-sm btn-copy-project-settings px-0"
                            id="copy-project-settings-btn_{{ copyFromLayerIndex }}"
                            type="button"
                    >
                        {{ 'project.copySettingsFromLayer' | translate }}
                    </button>
                </div>
                <div class="col-7">
                    <select
                            [(ngModel)]="copyFromLayerIndex"
                            class="form-control"
                            id="layer_to_copy_settings_from_{{ copyFromLayerIndex }}"
                            name="layer_to_copy_settings_from_{{ copyFromLayerIndex }}"
                    >
                        <option *ngFor="let layerToCopyFrom of layerNames; index as i" [ngValue]="i">
                            {{ layerToCopyFrom }}
                        </option>
                    </select>
                </div>
            </div>
        </ng-container>
    </div>
</div>
